export const endpointMapper = {
  v1: {
    admin: { "{type}": "gcd-admin" },
    myPage: { "{type}": "gcd-mypage" },
    billOfLading: { "{type}": "gcd-billoflading" },
    customsRelease: { "{type}": "gcd-customs-release" },
    portCall: { "{type}": "gcd-vessel-schedule" },
    location: { "{type}": "gcd-location" },
    workflow: { "{type}": "gcd-workflow-exception" },
    compliance: { "{type}": "gcd-compliance" },
    baplie: { "{type}": "gcd-bay-plan" },
    audit: { "{type}": "gcd-audit" },
    inbond: { "{type}": "gcd-inbonds" },
    inbondOrchestrator: { "{type}": "gcd-inbond-orchestrator" },
    dataAccumulationListener: { "{type}": "gcd-data-accumulation-listener" },
    notification: { "{type}": "gcd-notification" },
    rules: { "{type}": "gcd-rules" },
    user: { "{type}": "gcd-user" },
    vesselSchedule: { "{type}": "gcd-vessel-schedule" },
    aggregator: { "{type}": "api-aggregator" },
    orchestration: { "{type}": "gcd-orchestration" },
    fileOperations: { "{type}": "globalcustomsdeclaration-fileoperations" }
  },
  v2: {
    admin: { "{type}": "gcd-admin" },
    myPage: { "{type}": "gcd-mypage" },
    billoflading: { "{type}": "gcd-billoflading" },
    customsRelease: { "{type}": "gcd-customs-release" },
    portCall: { "{type}": "gcd-vessel-schedule" },
    location: { "{type}": "gcd-location" },
    workflow: { "{type}": "gcd-workflow-exception" },
    compliance: { "{type}": "gcd-compliance" },
    baplie: { "{type}": "gcd-bay-plan" },
    audit: { "{type}": "gcd-audit" },
    inbond: { "{type}": "gcd-inbonds" },
    inbondOrchestrator: { "{type}": "gcd-inbond-orchestrator" },
    dataAccumulationListener: { "{type}": "gcd-data-accumulation-listener" },
    notification: { "{type}": "gcd-notification" },
    rules: { "{type}": "gcd-rules" },
    user: { "{type}": "gcd-user" },
    vesselSchedule: { "{type}": "gcd-vessel-schedule" },
    aggregator: { "{type}": "api-aggregator" },
    orchestration: { "{type}": "gcd-orchestration" },
    fileOperations: { "{type}": "globalcustomsdeclaration-fileoperations" }
  },
  api: {}
};
